import React, { useState, useContext, useEffect } from 'react';
import { Button, Modal, Form, Input, Row, Col, Select, Spin, Divider, Switch, InputNumber, Space } from 'antd';
import utils from '../../../utils';
import http from '../../../Http';
import MapLocationGetter from './MapLocationGetter';
import { useTranslation } from 'react-i18next';

let timeout;
let currentSearchValue;
const fetch = (value, callback) => {
    if (timeout) {
        clearTimeout(timeout);
        timeout = null;
    }
    currentSearchValue = value;

    const fake = () => {
        http.post("inverter-v2/inverters-sns-mark-with-weather/get", {
            SN: value,
        }).then(async (r)=>{
            return await r.json();
        }).then((r) => {
            if (currentSearchValue === value) {
                const {data} = r;
                if (data) {
                    const opts = data.map((item) => ({
                        value: item["SN"],
                        label: item["SN"],
                        disabled: item["WithWeather"] == 1,
                    }))
                    callback (opts, null)
                } else {
                    callback (null, "")
                }
            }
        }).catch((e)=>{
            callback(null, "failed to load data")
            return null;
        });
    };
    timeout = setTimeout(fake, 300);
}

const timeOpts = [
    {value: (0*100)+0, label: "00:00"},
    {value: (0*100)+30, label: "00:30"},
    {value: (1*100)+0, label: "01:00"},
    {value: (1*100)+30, label: "01:30"},
    {value: (2*100)+0, label: "02:00"},
    {value: (2*100)+30, label: "02:30"},
    {value: (3*100)+0, label: "03:00"},
    {value: (3*100)+30, label: "03:30"},
    {value: (4*100)+0, label: "04:00"},
    {value: (4*100)+30, label: "04:30"},
    {value: (5*100)+0, label: "05:00"},
    {value: (5*100)+30, label: "05:30"},
    {value: (6*100)+0, label: "06:00"},
    {value: (6*100)+30, label: "06:30"},
    {value: (7*100)+0, label: "07:00"},
    {value: (7*100)+30, label: "07:30"},
    {value: (8*100)+0, label: "08:00"},
    {value: (8*100)+30, label: "08:30"},
    {value: (9*100)+0, label: "09:00"},
    {value: (9*100)+30, label: "09:30"},
    {value: (10*100)+0, label: "10:00"},
    {value: (10*100)+30, label: "10:30"},
    {value: (11*100)+0, label: "11:00"},
    {value: (11*100)+30, label: "11:30"},
    {value: (12*100)+0, label: "12:00"},
    {value: (12*100)+30, label: "12:30"},
    {value: (13*100)+0, label: "13:00"},
    {value: (13*100)+30, label: "13:30"},
    {value: (14*100)+0, label: "14:00"},
    {value: (14*100)+30, label: "14:30"},
    {value: (15*100)+0, label: "15:00"},
    {value: (15*100)+30, label: "15:30"},
    {value: (16*100)+0, label: "16:00"},
    {value: (16*100)+30, label: "16:30"},
    {value: (17*100)+0, label: "17:00"},
    {value: (17*100)+30, label: "17:30"},
    {value: (18*100)+0, label: "18:00"},
    {value: (18*100)+30, label: "18:30"},
    {value: (19*100)+0, label: "19:00"},
    {value: (19*100)+30, label: "19:30"},
    {value: (20*100)+0, label: "20:00"},
    {value: (20*100)+30, label: "20:30"},
    {value: (21*100)+0, label: "21:00"},
    {value: (21*100)+30, label: "21:30"},
    {value: (22*100)+0, label: "22:00"},
    {value: (22*100)+30, label: "22:30"},
    {value: (23*100)+0, label: "23:00"},
    {value: (23*100)+30, label: "23:30"},
]



function InverterWithWeatherAddOrModify({open, onOk, onCancel, info}) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [inverterSNopts, setInverterSNopts] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [location, setLocation] = useState({Longitude: undefined, Latitude: undefined});
    const [showGPSGetter, setShowGPSGetter] = useState(false);
    const setTip = useContext(utils.tipContext);

    const tip = "[InverterWithWeatherAddOrModify]";


    useEffect(()=>{
        let x = {...info};
        if (info.isNew) {
            x.InverterSN = x.InverterSN??"";
            // x.Longitude = x.Longitude?? 0;
            // x.Latitude = x.Latitude?? 0;
            x.STimeOfCharging = x.STimeOfCharging?? (0*100)+30;
            x.ETimeOfCharging = x.ETimeOfCharging?? (4*100)+0;
            x.ClearAndSunny = x.ClearAndSunny?? 30;
            x.MostlyClear = x.MostlyClear?? 65;
            x.PartlyCloudy = x.PartlyCloudy?? 80;
            x.MostlyCloudy = x.MostlyCloudy?? 90;
            x.Cloudy = x.Cloudy?? 95;
            x.Drizzle = x.Drizzle?? 80;
            x.Rain = x.Rain?? 80;
            x.LightRain = x.LightRain?? 85;
            x.HeavyRain = x.HeavyRain?? 100;
            x.Other = x.Other?? 90;
        }

        if (! isNaN(x.Longitude)) {
            x.Longitude = (x.Longitude*0.000001).toFixed(6);
        }
        if (! isNaN(x.Latitude)) {
            x.Latitude = (x.Latitude*0.000001).toFixed(6);
        }

        setLocation({Longitude: x.Longitude, Latitude: x.Latitude});
        
        form.setFieldsValue(x);
    }, [info])

    const handleSearch = (value) => {
        if (value) {
            setFetching(true);
            fetch(value, (opts, err) => {
                setFetching(false);
                if (err) {
                    setTip({ open: true, severity: "error", msg: t(err) });
                }
                setInverterSNopts(opts);
            })
        }
    }

    const handleOk = () => {
        setConfirmLoading(true);
        form.validateFields().then((values)=>{
            console.log(values);

            if (info.isNew) {
                values.isNew = true;
            }

            values.Longitude = Math.round(values.Longitude*1000000);
            values.Latitude = Math.round(values.Latitude*1000000);

            onOk(values);
        }).finally(()=>{
            setConfirmLoading(false);
        })
    }

    const handleGPSGetterOK = (location) => {
        setShowGPSGetter(false);

        if (location) {
            const lat = parseFloat(location.Latitude.toFixed(6));
            const lng = parseFloat(location.Longitude.toFixed(6));
            setLocation({Longitude: lng, Latitude: lat});
            form.setFieldsValue({Latitude:lat, Longitude:lng});
        }
    }

    return <Modal 
        title={info&&info.isNew ? t("Add Inverter Weather") : t("Edit Inverter Weather")} 
        visible={open} 
        onOk={handleOk} 
        confirmLoading={confirmLoading}
        onCancel={onCancel}
        width={"50%"}
        style={{minWidth: 600}}
    >
        <Form
            form={form}
            labelCol={{span: 12}}            
            style={{paddingRight: 20}}
            initialValues={info}
        >
            <Form.Item required={true} label={t("Inverter SN")} name="InverterSN" rules={[{required: true, message: t('Please input Inverter SN')}]}>
                {!info.isNew?<Input disabled={true}/>
                :<Select
                    showSearch={true}
                    showArrow={true}
                    placeholder={t("Please Enter Inverter SN and Select")}
                    options={inverterSNopts}
                    onSearch={handleSearch}
                    notFoundContent={fetching ? <Spin size="small" /> : null}
                />}
            </Form.Item>
            <Form.Item required={true} label={t("Location")} rules={[{required: true, message: t("required")}]}>
                <Space align="baseline">
                    <Form.Item required={true} name="Longitude" rules={[{required: true, message: t("required")}]} noStyle>
                        <InputNumber
                            style={{ width: 120 }}
                            placeholder={t("Longitude")}
                            min={-180}
                            max={180}
                            precision={6}
                            step={0.000001}
                        />
                    </Form.Item>
                    <span>,</span>
                    <Form.Item required={true} name="Latitude" rules={[{required: true, message: t("required")}]} noStyle>
                        <InputNumber
                            style={{ width: 120 }}
                            placeholder={t("Latitude")}
                            min={-90}
                            max={90}
                            precision={6}
                            step={0.000001}
                        />
                    </Form.Item>
                    <Button
                        icon={<img src="images/location.png" alt={t("Location")} style={{ width: 16, height: 16 }} />}
                        onClick={() => {
                            setShowGPSGetter(true);
                        }}
                    />
                </Space>
            </Form.Item>
            <Form.Item required={true} label={t("Charge Time Range")} rules={[{required: true}]} style={{ marginBottom: 0 }} >
                <Space>
                    <Form.Item required={true} name="STimeOfCharging" rules={[{required: true, message: t("required")}]}>
                        <Select style={{width: 90}} options={timeOpts}/>
                    </Form.Item>
                    <Form.Item>-</Form.Item>
                    <Form.Item required={true} name="ETimeOfCharging" rules={[{required: true, message: t("required")}]}>
                        <Select style={{width: 90}} options={timeOpts}/>
                    </Form.Item>
                </Space>
            </Form.Item>
            <Form.Item>
                <Divider orientation="middle">{t("Charge Percent(%) by Weather:")}</Divider>
            </Form.Item>
            <Form.Item label={t("Clear, Sunny")} name="ClearAndSunny" rules={[{ required: true, message: t("Required") }]}>
                <InputNumber
                    min={0}
                    max={100}
                />
            </Form.Item>
            <Form.Item label={t("Mostly Clear")} name="MostlyClear" rules={[{ required: true, message: t("Required") }]}>
                <InputNumber
                    min={0}
                    max={100}
                />
            </Form.Item>
            <Form.Item label={t("Partly Cloudy")} name="PartlyCloudy" rules={[{ required: true, message: t("Required") }]}>
                <InputNumber
                    min={0}
                    max={100}
                />
            </Form.Item>
            <Form.Item label={t("Mostly Cloudy")} name="MostlyCloudy" rules={[{ required: true, message: t("Required") }]}>
                <InputNumber
                    min={0}
                    max={100}
                />
            </Form.Item>
            <Form.Item label={t("Cloudy")} name="Cloudy" rules={[{ required: true, message: t("Required") }]}>
                <InputNumber
                    min={0}
                    max={100}
                />
            </Form.Item>
            <Form.Item label={t("Drizzle")} name="Drizzle" rules={[{ required: true, message: t("Required") }]}>
                <InputNumber
                    min={0}
                    max={100}
                />
            </Form.Item>
            <Form.Item label={t("Rain")} name="Rain" rules={[{ required: true, message: t("Required") }]}>
                <InputNumber
                    min={0}
                    max={100}
                />
            </Form.Item>
            <Form.Item label={t("Light Rain")} name="LightRain" rules={[{ required: true, message: t("Required") }]}>
                <InputNumber
                    min={0}
                    max={100}
                />
            </Form.Item>
            <Form.Item label={t("Heavy Rain")} name="HeavyRain" rules={[{ required: true, message: t("Required") }]}>
                <InputNumber
                    min={0}
                    max={100}
                />
            </Form.Item>
            <Form.Item label={t("Other")} name="Other" rules={[{ required: true, message: t("Required") }]}>
                <InputNumber
                    min={0}
                    max={100}
                />
            </Form.Item>
        </Form>
        <MapLocationGetter show={showGPSGetter} onCancel={()=>setShowGPSGetter(false)} onOK={handleGPSGetterOK} centerPoint={location} />
    </Modal>
}

export default InverterWithWeatherAddOrModify;
